import api from '../../api/languages';

export default {
    state: {
        languages: null,
    },
    getters: {
        getLanguages: (state) => state.languages && state.languages.sort(),
    },
    mutations: {
        SET_LANGUAGES_DATA(state, payload) {
            state.languages = payload;
        },
    },
    actions: {
        fetchLanguages({
            commit
        }) {
            api.get().then(({
                data: {
                    data: {
                        languages
                    }
                },
                status
            }) => {
                if (status === 200) {
                    commit('SET_LANGUAGES_DATA', Object.values(languages));
                }
            });
        }
    },
};